import {
  AnimalSizeEnum,
  CountryCode,
  CouplingType,
  DogBreederApplicationExperience,
  DogBreederApplicationOtherAnimal,
  DogHairType,
} from '@gql/graphql';
import type { TFunction } from 'i18next';

export type Language = 'fr' | 'nl' | 'de' | 'en';

export type Country = 'be' | 'fr' | 'nl' | 'de' | 'ch' | 'eu';

export type AccountType = 'buyer' | 'breeder';

export type Translate = TFunction;

export type PedigreeType = 'FCI' | string | null;

export type PedigreeTypePresentation = 'FCI' | 'OTHER' | 'NONE';

export type ValueOf<T> = T[keyof T];

export type PageState = 'loading' | 'error' | 'empty' | 'data';

export interface CachedContactMessage {
  breederId: number;
  createdAt: number;
  email: string;
  message: string;
}

export type Route =
  | 'article'
  | 'articleList'
  | 'breed'
  | 'breeder'
  | 'breederList'
  | 'breederLinks'
  | 'breederReview'
  | 'breedList'
  | 'stud'
  | 'studList'
  | 'groomer'
  | 'groomerList'
  | 'educatorList'
  | 'educator'
  | 'educatorReview'
  | 'homeLanding'
  | 'breederLanding'
  | 'joinBreeder'
  | 'joinBuyer'
  | 'joinGroomer'
  | 'joinLanding'
  | 'joinShelter'
  | 'joinVet'
  | 'joinEducator'
  | 'litter'
  | 'litterList'
  | 'login'
  | 'proLanding'
  | 'quiz'
  | 'quizResults'
  | 'profile'
  | 'shelter'
  | 'shelterList'
  | 'vet'
  | 'vetList'
  | 'vetLocationLinks'
  | 'litterLinks'
  | 'groomerLocationLinks'
  | 'educatorLocationLinks'
  | 'story'
  | 'contact'
  | 'chart'
  | 'terms'
  | 'impressum'
  | 'thankyou'
  | 'feedback'
  | 'team'
  | 'privacy'
  | 'cookies'
  | 'booking'
  | 'mtProfile'
  | 'mtOnboarding'
  | 'mtPage'
  | 'mtBreederProfile'
  | 'mtAdoptions'
  | 'mtAppointments'
  | 'mtAnimals'
  | 'mtWishlist'
  | 'mtMessages'
  | 'mtSettings'
  | 'mtPayments'
  | 'mtLitters'
  | 'mtLanding'
  | 'service'
  | 'story'
  | 'joinProInfoBookingVet'
  | 'joinProInfoProfileVet'
  | 'joinProInfoSeoVet'
  | 'joinProInfoAgendaVet'
  | 'joinProInfoBookingGroomer'
  | 'joinProInfoProfileGroomer'
  | 'joinProInfoSeoGroomer'
  | 'joinProInfoAgendaGroomer'
  | 'resetPassword'
  | 'agendaConfig'
  | 'application'
  | 'mtApplications'
  | 'mtApplicationCheckoutSuccess'
  | 'mtApplicationCheckoutFailed'
  | 'mtOwners'
  | 'mtWaitingList'
  | 'mtFaq'
  | 'mtAdvantages'
  | 'mtPuppyGuide'
  | 'mtContact'
  | 'faqBreeder'
  | 'faqBuyer'
  | 'breedComparator'
  | 'unsubscribe'
  | 'publicUnsubscribe';

export const countryToRelavanceWord: Record<CountryCode, string> = {
  [CountryCode.BE]: 'belgium',
  [CountryCode.FR]: 'france',
  [CountryCode.NL]: 'nederland',
  [CountryCode.DE]: 'germany',
  [CountryCode.CH]: 'switzerland',
  [CountryCode.CA]: 'canada',
  [CountryCode.EU]: '',
};

export enum BreedMaintenanceType {
  LITTLE = 'LITTLE',
  AVERAGE = 'AVERAGE',
  MUCH = 'MUCH',
}

export enum BreedFciGroupType {
  levrier = 'levrier',
  courant = 'courant',
  terriers = 'terriers',
  spitz = 'spitz',
  berger = 'berger',
  compagnie = 'compagnie',
  arret = 'arret',
  teckel = 'teckel',
  gibier = 'gibier',
  pinscher = 'pinscher',
}

export enum DogHairTypeOrdered {
  SHORT = DogHairType.SHORT,
  SEMI_LONG = DogHairType.SEMI_LONG,
  LONG = DogHairType.LONG,
  CURLY = DogHairType.CURLY,
}

export enum AnimalSizeTypeOrdered {
  SMALL = AnimalSizeEnum.SMALL,
  MEDIUM = AnimalSizeEnum.MEDIUM,
  BIG = AnimalSizeEnum.BIG,
}

export enum ApplicationType {
  APPLICATIONS = 'APPLICATIONS',
  OWNERS = 'OWNERS',
  WAITING_LIST = 'WAITING_LIST',
}

export enum CouplingTypeOrdered {
  NATURAL = CouplingType.NATURAL,
  FRESH_ARTIFICIAL = CouplingType.FRESH_ARTIFICIAL,
  REFRIGERATED_ARTIFICIAL = CouplingType.REFRIGERATED_ARTIFICIAL,
  FROZEN_ARTIFICIAL = CouplingType.FROZEN_ARTIFICIAL,
}

export enum DogBreederApplicationOtherAnimalLimited {
  DOGS = DogBreederApplicationOtherAnimal.DOGS,
  CATS = DogBreederApplicationOtherAnimal.CATS,
  OTHER = DogBreederApplicationOtherAnimal.OTHER,
  NONE = DogBreederApplicationOtherAnimal.NONE,
}

export enum DogBreederApplicationExperienceLimited {
  OWNED = DogBreederApplicationExperience.OWNED,
  LIVED_PARTNER = DogBreederApplicationExperience.LIVED_PARTNER,
  WORKED = DogBreederApplicationExperience.WORKED,
  NONE = DogBreederApplicationExperience.NONE,
}

export enum SocialLoginMethod {
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
}
